<!-- modal-add-client.component.html -->
<div class="modal-all" [formGroup]="clientForm">
  <!-- ═══ HEADER ═══ -->
  <header class="modal-header">
    <h4 class="modal-title">
      {{
        action === "ad"
          ? ("comercial.clients.modal-add-client.title_new" | translate)
          : ("comercial.clients.modal-add-client.title_edit" | translate)
      }}
    </h4>

    <button
      type="button"
      class="btn-close"
      aria-label="Cerrar"
      (click)="closeCanvas()"
    ></button>
  </header>

  <!-- ═══ BODY ═══ -->
  <main class="modal-body">
    <!-- contenedor para dropdowns Taiga -->
    <div id="modal_show_countries_phones"></div>

    <!-- =================================================
         1. INFORMACIÓN DE CLIENTE
    ================================================== -->
    <fieldset class="section">
      <span class="section__title">
        {{
          "comercial.clients.modal-add-client.section_clientInfo" | translate
        }}
      </span>

      <!-- Zona operativa -->
      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_zone" | translate }}*
        </label>
        <ng-select
          formControlName="zone"
          [items]="zones"
          bindLabel="zoneName"
          bindValue="zoneName"
          [loading]="loadingZones"
          [placeholder]="
            'comercial.clients.modal-add-client.placeholder_selectZone'
              | translate
          "
          class="input_form"
        ></ng-select>
        <div
          *ngIf="
            clientForm.get('zone')?.hasError('required') &&
            clientForm.get('zone')?.touched
          "
          class="error-msg"
        >
          {{
            "comercial.clients.modal-add-client.error_selectZone" | translate
          }}
        </div>
      </div>

      <!-- Empresa -->
      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_companyName" | translate
          }}*
        </label>
        <tui-input
          formControlName="companyName"
          class="input_form"
          [tuiTextfieldLabelOutside]="true"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_companyName"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('companyName')?.hasError('required') &&
            clientForm.get('companyName')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <!-- KAM -->
      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_keyAccount" | translate
          }}*
        </label>
        <tui-input
          formControlName="keyAccount"
          class="input_form"
          [tuiTextfieldLabelOutside]="true"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_keyAccount"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('keyAccount')?.hasError('required') &&
            clientForm.get('keyAccount')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <!-- Estado -->
      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_status" | translate }}*
        </label>
        <ng-select
          formControlName="status"
          [items]="statusesTranslated"
          bindLabel="name"
          bindValue="value"
          [clearable]="false"
          class="input_form"
          [placeholder]="
            'comercial.clients.modal-add-client.placeholder_status' | translate
          "
        ></ng-select>
        <div
          *ngIf="
            clientForm.get('status')?.hasError('required') &&
            clientForm.get('status')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <!-- Tipo -->
      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_type" | translate }}*
        </label>
        <ng-select
          formControlName="type"
          [items]="clientTypeOptions"
          bindValue="value"
          class="input_form"
          [placeholder]="'common.clientTypes.selectClientType' | translate"
          [clearable]="false"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ "common.clientTypes." + item.label | translate }}
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            {{ "common.clientTypes." + item.label | translate }}
          </ng-template>
        </ng-select>
        <div
          *ngIf="
            clientForm.get('type')?.hasError('required') &&
            clientForm.get('type')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <!-- Grupo / Subgrupo -->
      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_group" | translate }}
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="group"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_group" | translate
          }}
        </tui-input>
      </div>
      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_subGroup" | translate }}
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="subGroup"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_subGroup"
              | translate
          }}
        </tui-input>
      </div>

      <!-- Observaciones -->
      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_additionalInfo"
              | translate
          }}
        </label>
        <textarea
          formControlName="additionalInfo"
          rows="3"
          class="form-control-text-area"
          [placeholder]="
            'comercial.clients.modal-add-client.placeholder_additionalInfo'
              | translate
          "
        ></textarea>
      </div>
    </fieldset>

    <!-- =================================================
         2. CONTACTO PRINCIPAL
    ================================================== -->
    <fieldset class="section">
      <span class="section__title">
        {{
          "comercial.clients.modal-add-client.section_mainContact" | translate
        }}
      </span>

      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_name" | translate }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="name"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_name" | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('name')?.hasError('required') &&
            clientForm.get('name')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_lastName" | translate }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="lastName"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_lastName"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('lastName')?.hasError('required') &&
            clientForm.get('lastName')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <!-- Teléfono -->
      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_officePhone" | translate
          }}*
        </label>
        <tui-input-phone-international
          [tuiTextfieldLabelOutside]="true"
          formControlName="officePhone"
          [countries]="(countryCodes | tuiSortCountries | async) || []"
          [countryIsoCode]="clientForm.get('officePhoneIso')!.value"
          (countryIsoCodeChange)="
            clientForm.get('officePhoneIso')!.setValue($event)
          "
          (click)="openPhoneContainer($event)"
          class="input_form"
        >
          {{ phoneExample$ | async }}
        </tui-input-phone-international>
        <div
          *ngIf="
            clientForm.get('officePhone')?.invalid &&
            clientForm.get('officePhone')?.touched
          "
          class="error-msg"
        >
          {{
            "comercial.clients.modal-add-client.error_invalidPhone" | translate
          }}
        </div>
      </div>

      <!-- Email -->
      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_corporateEmail"
              | translate
          }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="corporateEmail"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_corporateEmail"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('corporateEmail')?.invalid &&
            clientForm.get('corporateEmail')?.touched
          "
          class="error-msg"
        >
          {{
            "comercial.clients.modal-add-client.error_invalidEmail" | translate
          }}
        </div>
      </div>
    </fieldset>

    <!-- =================================================
         3. CONTACTOS ADICIONALES
    ================================================== -->
    <fieldset class="section">
      <div class="flex-container">
        <span class="section__title">
          {{
            "comercial.clients.modal-add-client.section_additionalContacts"
              | translate
          }}
        </span>
        <tui-icon
          icon="tuiIconPlusCircleLarge"
          class="section__action"
          (click)="addContact()"
        ></tui-icon>
      </div>

      <div *ngIf="contactsArray.length === 0" class="empty-state">
        <p class="empty-state__text">
          {{
            "comercial.clients.modal-add-client.placeholder_noContacts"
              | translate
          }}
        </p>

        <!-- [ER - 19/06/2025] - Commented if we need in a future-->
        <!-- <button type="button" class="link-button" (click)="addContact()">
          {{
            "comercial.clients.modal-add-client.action_addContact" | translate
          }}
        </button> -->
      </div>

      <div formArrayName="contacts">
        <ng-container
          *ngFor="let c of contactsArray.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="contact-card">
            <header>
              <b>
                {{
                  ("comercial.clients.modal-add-client.section_additionalContacts"
                    | translate) +
                    " " +
                    (i + 1)
                }}
              </b>
              <tui-icon
                icon="tuiIconTrash2"
                class="trash-icon"
                (click)="removeContact(i)"
              ></tui-icon>
            </header>

            <div class="contact-card-input-container">
              <div class="form-field">
                <label class="label_form">
                  {{
                    "comercial.clients.modal-add-client.label_name" | translate
                  }}*
                </label>
                <tui-input
                  [tuiTextfieldLabelOutside]="true"
                  formControlName="firstName"
                  class="input_form"
                >
                  {{
                    "comercial.clients.modal-add-client.placeholder_contactName"
                      | translate
                  }}
                </tui-input>

                <div
                  *ngIf="
                    c.get('firstName')?.hasError('required') &&
                    c.get('firstName')?.touched
                  "
                  class="error-msg"
                >
                  {{
                    "comercial.clients.modal-add-client.error_required"
                      | translate
                  }}
                </div>
              </div>

              <div class="form-field">
                <label class="label_form">
                  {{
                    "comercial.clients.modal-add-client.label_lastName"
                      | translate
                  }}*
                </label>
                <tui-input
                  [tuiTextfieldLabelOutside]="true"
                  formControlName="lastName"
                  class="input_form"
                >
                  {{
                    "comercial.clients.modal-add-client.placeholder_contactLastName"
                      | translate
                  }}
                </tui-input>
                <div
                  *ngIf="
                    c.get('lastName')?.hasError('required') &&
                    c.get('lastName')?.touched
                  "
                  class="error-msg"
                >
                  {{
                    "comercial.clients.modal-add-client.error_required"
                      | translate
                  }}
                </div>
              </div>

              <div class="form-field">
                <label class="label_form">
                  {{
                    "comercial.clients.modal-add-client.label_contactEmail"
                      | translate
                  }}*
                </label>
                <tui-input
                  [tuiTextfieldLabelOutside]="true"
                  formControlName="contactEmailAddress"
                  class="input_form"
                >
                  {{
                    "comercial.clients.modal-add-client.placeholder_contactEmail"
                      | translate
                  }}
                </tui-input>
                <div
                  *ngIf="
                    c.get('contactEmailAddress')?.invalid &&
                    c.get('contactEmailAddress')?.touched
                  "
                  class="error-msg"
                >
                  {{
                    "comercial.clients.modal-add-client.error_invalidEmail"
                      | translate
                  }}
                </div>
              </div>

              <div class="form-field">
                <label class="label_form">
                  {{
                    "comercial.clients.modal-add-client.label_department"
                      | translate
                  }}*
                </label>
                <ng-select
                  formControlName="department"
                  [items]="contactDepartments"
                  bindValue="value"
                  [placeholder]="
                    'comercial.clients.modal-add-client.placeholder_department'
                      | translate
                  "
                  class="input_form"
                  [clearable]="false"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ "common.contactDepartments." + item.label | translate }}
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item">
                    {{ "common.contactDepartments." + item.label | translate }}
                  </ng-template>
                </ng-select>

                <div
                  *ngIf="
                    c.get('department')?.hasError('required') &&
                    c.get('department')?.touched
                  "
                  class="error-msg"
                >
                  {{
                    "comercial.clients.modal-add-client.error_required"
                      | translate
                  }}
                </div>
              </div>

              <div class="form-field">
                <label class="label_form">
                  {{
                    "comercial.clients.modal-add-client.label_phone"
                      | translate
                  }}*
                </label>
                <tui-input-phone-international
                  [tuiTextfieldLabelOutside]="true"
                  formControlName="phoneNumber"
                  [countries]="(countryCodes | tuiSortCountries | async) || []"
                  [countryIsoCode]="c.get('phoneIso')?.value"
                  (countryIsoCodeChange)="c.get('phoneIso')?.setValue($event)"
                  (click)="openPhoneContainer($event)"
                  class="input_form"
                >
                  {{
                    "comercial.clients.modal-add-client.placeholder_contactPhone"
                      | translate
                  }}
                </tui-input-phone-international>
                <div
                  *ngIf="
                    c.get('phoneNumber')?.invalid &&
                    c.get('phoneNumber')?.touched
                  "
                  class="error-msg"
                >
                  {{
                    "comercial.clients.modal-add-client.error_invalidPhone"
                      | translate
                  }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </fieldset>

    <!-- =================================================
         4. DATOS DE FACTURACIÓN
    ================================================== -->
    <fieldset class="section">
      <span class="section__title">
        {{
          "comercial.clients.modal-add-client.section_billingData" | translate
        }}
      </span>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_billingName" | translate
          }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="billingName"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_billingName"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('billingName')?.hasError('required') &&
            clientForm.get('billingName')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_billingCIF" | translate
          }}*
        </label>
        <tui-input
          formControlName="billingCIF"
          class="input_form"
          [tuiTextfieldLabelOutside]="true"
          (input)="onLimitLength($event, 20, 'billingCIF')"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_billingCIF"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('billingCIF')?.hasError('required') &&
            clientForm.get('billingCIF')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_billingAddress"
              | translate
          }}*
        </label>
        <input
          #addressBilling
          formControlName="billingAddress"
          type="text"
          class="input-standar"
          [placeholder]="
            'comercial.clients.modal-add-client.placeholder_billingAddress'
              | translate
          "
        />

        <div
          *ngIf="
            clientForm.get('billingAddress')?.hasError('required') &&
            clientForm.get('billingAddress')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_postalCode" | translate
          }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="postalCode"
          class="input_form"
          (input)="onLimitLength($event, 12, 'postalCode')"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_postalCode"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('postalCode')?.hasError('required') &&
            clientForm.get('postalCode')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_city" | translate }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="city"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_city" | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('city')?.hasError('required') &&
            clientForm.get('city')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_province" | translate }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="province"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_province"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('province')?.hasError('required') &&
            clientForm.get('province')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{ "comercial.clients.modal-add-client.label_country" | translate }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="country"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_country" | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('country')?.hasError('required') &&
            clientForm.get('country')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_billingDetails"
              | translate
          }}
        </label>
        <textarea
          formControlName="billingDetails"
          rows="3"
          class="form-control-text-area"
          [placeholder]="
            'comercial.clients.modal-add-client.label_billingDetails'
              | translate
          "
        ></textarea>
      </div>
    </fieldset>

    <!-- =================================================
         5. INFORMACIÓN BANCARIA
    ================================================== -->
    <fieldset class="section">
      <span class="section__title">
        {{ "comercial.clients.modal-add-client.section_bankInfo" | translate }}
      </span>

      <!-- Método de pago -->
      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_paymentMethod"
              | translate
          }}*
        </label>
        <ng-select
          formControlName="paymentMethod"
          [items]="paymentMethods"
          bindValue="value"
          class="input_form"
          [placeholder]="
            'common.paymentMethods.selectPaymentMethod' | translate
          "
          [clearable]="false"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ "common.paymentMethods." + item.label | translate }}
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            {{ "common.paymentMethods." + item.label | translate }}
          </ng-template>
        </ng-select>
        <div
          *ngIf="
            clientForm.get('paymentMethod')?.hasError('required') &&
            clientForm.get('paymentMethod')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <!-- IBAN y SWIFT -->
      <ng-container
        *ngIf="requiresBankData(clientForm.get('paymentMethod')?.value)"
      >
        <div class="form-field">
          <label class="label_form">
            {{ "comercial.clients.modal-add-client.label_iban" | translate }}*
          </label>
          <tui-input
            formControlName="iban"
            (input)="onLimitLength($event, 34, 'iban'); formatIban($event)"
            class="input_form"
            [tuiTextfieldLabelOutside]="true"
          >
            {{
              "comercial.clients.modal-add-client.placeholder_iban" | translate
            }}
          </tui-input>
          <div
            *ngIf="
              clientForm.get('iban')?.invalid && clientForm.get('iban')?.touched
            "
            class="error-msg"
          >
            {{
              "comercial.clients.modal-add-client.error_invalidIban" | translate
            }}
          </div>
        </div>

        <div class="form-field">
          <label class="label_form">
            {{ "comercial.clients.modal-add-client.label_swift" | translate }}*
          </label>
          <tui-input
            formControlName="swift"
            class="input_form"
            [tuiTextfieldLabelOutside]="true"
            (input)="onLimitLength($event, 11, 'swift')"
          >
            {{
              "comercial.clients.modal-add-client.placeholder_swift" | translate
            }}
          </tui-input>
          <div
            *ngIf="
              clientForm.get('swift')?.invalid &&
              clientForm.get('swift')?.touched
            "
            class="error-msg"
          >
            {{
              "comercial.clients.modal-add-client.error_invalidSwift"
                | translate
            }}
          </div>
        </div>
      </ng-container>

      <!-- Repercusión de gastos -->
      <div class="expense-chargeback" formArrayName="rebilledExpenseCategories">
        <span class="expense-chargeback__title">
          {{
            "comercial.clients.modal-add-client.section_expenseChargeback"
              | translate
          }}
        </span>
        <p class="expense-chargeback__hint">
          {{
            "comercial.clients.modal-add-client.expenseChargeback_hint"
              | translate
          }}
        </p>
        <div class="expense-chargeback__list">
          <label
            class="expense-chargeback__item"
            *ngFor="let category of expenseCategories; let i = index"
          >
            <tui-checkbox [formControlName]="i" size="m"></tui-checkbox>
            {{ expenseCategoryLabels[category] | translate }}
          </label>
        </div>
      </div>
    </fieldset>

    <!-- =================================================
         6. CONTACTO DE FACTURACIÓN
    ================================================== -->
    <fieldset class="section">
      <span class="section__title">
        {{
          "comercial.clients.modal-add-client.section_billingContact"
            | translate
        }}
      </span>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_paymentContactName"
              | translate
          }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="paymentContactName"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_paymentContactName"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('paymentContactName')?.hasError('required') &&
            clientForm.get('paymentContactName')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_paymentContactLastName"
              | translate
          }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="paymentContactLastName"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_paymentContactLastName"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('paymentContactLastName')?.hasError('required') &&
            clientForm.get('paymentContactLastName')?.touched
          "
          class="error-msg"
        >
          {{ "comercial.clients.modal-add-client.error_required" | translate }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_paymentContactEmail"
              | translate
          }}*
        </label>
        <tui-input
          [tuiTextfieldLabelOutside]="true"
          formControlName="paymentContactEmail"
          class="input_form"
        >
          {{
            "comercial.clients.modal-add-client.placeholder_paymentContactEmail"
              | translate
          }}
        </tui-input>
        <div
          *ngIf="
            clientForm.get('paymentContactEmail')?.invalid &&
            clientForm.get('paymentContactEmail')?.touched
          "
          class="error-msg"
        >
          {{
            "comercial.clients.modal-add-client.error_invalidEmail" | translate
          }}
        </div>
      </div>

      <div class="form-field">
        <label class="label_form">
          {{
            "comercial.clients.modal-add-client.label_paymentContactPhone"
              | translate
          }}*
        </label>
        <tui-input-phone-international
          formControlName="paymentContactPhone"
          [tuiTextfieldLabelOutside]="true"
          [countries]="(countryCodes | tuiSortCountries | async) || []"
          [countryIsoCode]="clientForm.get('paymentContactPhoneIso')?.value"
          (countryIsoCodeChange)="
            clientForm.get('paymentContactPhoneIso')?.setValue($event)
          "
          (click)="openPhoneContainer($event)"
          class="input_form"
        >
          {{ payPhoneExample$ | async }}
        </tui-input-phone-international>
        <div
          *ngIf="
            clientForm.get('paymentContactPhone')?.invalid &&
            clientForm.get('paymentContactPhone')?.touched
          "
          class="error-msg"
        >
          {{
            "comercial.clients.modal-add-client.error_invalidPhone" | translate
          }}
        </div>
      </div>
    </fieldset>
  </main>

  <!-- ═══ FOOTER ═══ -->
  <div class="modal-footer">
    <button
      class="cancel-button"
      type="button"
      (click)="closeCanvas()"
      [disabled]="isSaving"
    >
      {{ "comercial.clients.modal-add-client.button_discard" | translate }}
    </button>

    <button
      class="confirm-button"
      type="button"
      (click)="saveClient()"
      [disabled]="isSaving"
    >
      <ng-container *ngIf="isSaving; else labelTpl">
        <tui-loader size="xs"></tui-loader>
      </ng-container>

      <ng-template #labelTpl>
        <ng-container [ngSwitch]="action">
          <span *ngSwitchCase="'ed'">
            {{ "comercial.clients.modal-add-client.button_save" | translate }}
          </span>
          <span *ngSwitchDefault>
            {{ "comercial.clients.modal-add-client.button_add" | translate }}
          </span>
        </ng-container>
      </ng-template>
    </button>
  </div>
</div>
